<template>
  <v-navigation-drawer persistent enable-resize-watcher app
                       :value="sideNav"
                       @input="val => toggleNav(val)"
                       class="deep-purple darken-4 white--text inset-elevation-3 navigation-drawer navigation-drawer--fixed navigation-drawer--open">
    <active-user-badge v-if="activeUser && activeUser.userName"></active-user-badge>
    <router-links-list @closeMe="closeNav()"></router-links-list>
  </v-navigation-drawer>
</template>
<script>
  import ActiveUserBadge from './components/ActiveUserBadge'
  import RouterLinksList from './components/RouterLinks'

  export default{
    components: {
      RouterLinksList,
      ActiveUserBadge
    },
    name: 'side-nav-left',
    props: {
      sideNav: {
        type: Boolean,
        default: false
      },
      activeUser: {
        type: Object
      },
    },
    data () {
      return {
        counter: 0,
          initalized: false
      }
    },
    methods: {
      toggleNav(val) {
          this.$emit('updateSideNav', val)
      /*  if(this.sideNav === true && this.counter >= 1) {
          this.$emit('toggledLeftNav')
          this.counter = 0
        } else {
          this.counter++
        }*/
      },
      closeNav() {
        if(this.sideNav === true) {
          this.$emit('toggledLeftNav')
          this.counter = -1
        }
      }
    },
  }
</script>
<style lang="scss">
  #active_user_badge {
    cursor: pointer;
    &:hover i {
      color: black;
      text-shadow: white 1px 0 2px;
      font-size: 18px;
    }
    i {
      margin-bottom: -10px;
      font-size: 15px;
    }
    &:hover .edit-profile {
      box-shadow: inset black 0 0 2px;
    }
    a {
      color: white;
    }
  }
</style>
